// extracted by mini-css-extract-plugin
module.exports = {"root":"about-services-module--root--2i4gw","list":"about-services-module--list--1geEJ","listItem":"about-services-module--list-item--uQ4Pe"};